import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "silicone-vs-elastomeric-roof-coatings-for-foam-roofs-in-phoenix";
export const Route = createFileRoute("/silicone-vs-elastomeric-roof-coatings-for-foam-roofs-in-phoenix")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
